(() => {
  'use strict';

  const SEL = '[data-nebula-gp]';
  let timer = null;
  let bypassPopup = false;

  const getRoot = () => {
    const r = window.Shopify?.routes?.root || '/';
    return `${r}`.replace(/\/?$/, '/');
  };

  const getConfig = () => {
    const el = document.querySelector(SEL);
    if (!el) return null;
    return {
      giftVariant: Number(el.dataset.giftVariant || 0),
      threshold: Number(el.dataset.threshold || 0),
      currency: el.dataset.currency || 'EGP',
      locale: el.dataset.locale || document.documentElement.lang || 'ar',
      popup: el.dataset.popup === 'true',
      giftImage: el.dataset.giftImage || ''
    };
  };

  const isAr = (l) => `${l}`.toLowerCase().startsWith('ar');

  const money = (cents, cfg) => {
    try {
      return new Intl.NumberFormat(cfg.locale, {
        style: 'currency', currency: cfg.currency, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return `${Math.round(cents / 100)} ${cfg.currency}`;
    }
  };

  const eligibleTotal = (cart, cfg) =>
    cart.items.reduce((sum, item) => {
      if (cfg.giftVariant && Number(item.variant_id) === cfg.giftVariant) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);

  let lastState = { total: 0, remaining: 0, complete: false };

  const render = (cart, cfg) => {
    const total = eligibleTotal(cart, cfg);
    const remaining = Math.max(cfg.threshold - total, 0);
    const percent = cfg.threshold ? Math.min((total / cfg.threshold) * 100, 100) : 0;
    const complete = total >= cfg.threshold;
    const ar = isAr(cfg.locale);

    lastState = { total, remaining, complete };

    document.querySelectorAll(SEL).forEach((card) => {
      card.classList.toggle('is-complete', complete);
      const bar = card.querySelector('[data-gp-bar]');
      const msg = card.querySelector('[data-gp-msg]');
      const totals = card.querySelector('[data-gp-totals]');

      if (bar) bar.style.width = `${percent}%`;
      if (totals) totals.textContent = `${money(total, cfg)} / ${money(cfg.threshold, cfg)}`;
      if (msg) {
        msg.textContent = complete
          ? (ar ? 'مبروك! الـPouch اتضافت هدية على طلبك 🎉'
                : 'Congrats! Your free Pouch was added 🎉')
          : (ar ? `باقيلك ${money(remaining, cfg)} وتاخدي الـPouch هدية 🎁`
                : `Spend ${money(remaining, cfg)} more to get a free Pouch 🎁`);
      }
    });
  };

  const sync = async () => {
    const cfg = getConfig();
    if (!cfg) return;
    try {
      const res = await fetch(`${getRoot()}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      const cart = await res.json();
      render(cart, cfg);
    } catch (e) {
      console.error('[Nebula GP]', e);
    }
  };

  const schedule = (delay = 250) => {
    clearTimeout(timer);
    timer = setTimeout(sync, delay);
  };

  /* ===== Popup ===== */
  const buildPopup = (cfg) => {
    let popup = document.getElementById('nebulaGpPopup');
    if (popup) return popup;

    const ar = isAr(cfg.locale);
    popup = document.createElement('div');
    popup.id = 'nebulaGpPopup';
    popup.className = 'nebula-gp-popup';
    popup.innerHTML = `
      <div class="nebula-gp-popup__overlay" data-gp-close></div>
      <div class="nebula-gp-popup__box" ${ar ? 'dir="rtl"' : ''}>
        ${cfg.giftImage ? `<img class="nebula-gp-popup__img" src="${cfg.giftImage}" alt="">` : ''}
        <h3 class="nebula-gp-popup__title">${ar ? 'استني ثانية! 🎁' : 'Wait a second! 🎁'}</h3>
        <p class="nebula-gp-popup__text" data-gp-popup-text></p>
        <div class="nebula-gp__track"><span data-gp-popup-bar style="width:0"></span></div>
        <button type="button" class="nebula-gp-popup__btn nebula-gp-popup__btn--primary" data-gp-close>
          ${ar ? 'كمّلي التسوق' : 'Keep shopping'}
        </button>
        <button type="button" class="nebula-gp-popup__btn nebula-gp-popup__btn--ghost" data-gp-continue>
          ${ar ? 'أكملي للدفع على أي حال' : 'Continue to checkout anyway'}
        </button>
      </div>`;
    document.body.appendChild(popup);

    popup.addEventListener('click', (e) => {
      if (e.target.closest('[data-gp-close]')) {
        popup.classList.remove('is-open');
      }
      if (e.target.closest('[data-gp-continue]')) {
        popup.classList.remove('is-open');
        bypassPopup = true;
        window.location.href = `${getRoot()}checkout`;
      }
    });

    return popup;
  };

  const showPopup = (cfg) => {
    const popup = buildPopup(cfg);
    const ar = isAr(cfg.locale);
    const text = popup.querySelector('[data-gp-popup-text]');
    const bar = popup.querySelector('[data-gp-popup-bar]');
    const percent = cfg.threshold
      ? Math.min((lastState.total / cfg.threshold) * 100, 100) : 0;

    if (text) {
      text.textContent = ar
        ? `باقيلك ${money(lastState.remaining, cfg)} بس وتاخدي الـPouch هدية مجانية!`
        : `You're only ${money(lastState.remaining, cfg)} away from a free Pouch!`;
    }
    if (bar) bar.style.width = `${percent}%`;
    popup.classList.add('is-open');
  };

  /* اعتراض زرار الـCheckout */
  document.addEventListener('click', (e) => {
    const cfg = getConfig();
    if (!cfg || !cfg.popup || bypassPopup) return;
    if (lastState.complete || lastState.total === 0) return;

    const btn = e.target.closest(
      '[name="checkout"], a[href*="/checkout"], button[form][formaction*="/checkout"]'
    );
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    showPopup(cfg);
  }, true);

  /* مراقبة أي تغيير في الكارت */
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const p = origFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.finally(() => schedule(300));
    }
    return p;
  };

  if (window.jQuery) {
    jQuery(document).ajaxComplete((e, xhr, settings) => {
      if (/\/cart\/(add|change|update|clear)/.test(settings.url || '')) schedule(300);
    });
  }

  document.addEventListener('DOMContentLoaded', () => schedule(100));
  document.addEventListener('cart:updated', () => schedule(150));
  window.addEventListener('pageshow', () => schedule(150));
})();